//import scroll-lock package dependancy
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { setFillGapMethod, addFillGapTarget, addFillGapSelector, removeFillGapSelector, getPageScrollBarWidth } from 'scroll-lock';

// import GSAP from 'gsap'

import Component from './../classes/Component'

import { mapEach } from './../utils/dom'

export default class Modal extends Component {
  constructor ({ template, target }) {
    super({
      element: `[data-modal-target="${target}"]`,
      elements: {
        scrollable: `[data-scrollable]`,
      }
    })

    this.toggle = document.querySelector(`[data-modal-toggle="${target}"]`)
    this.state = 'hidden'

    this.scrollLockInit()
  }

  scrollLockInit() {
    this.scrollableElement = this.elements.scrollable
    this.fillGapElement = document.querySelector('.c-header')
    this.fillGapMethod = 'padding' //Available methods: none, padding, margin, width, max-width
    this.fillGapSelector = '[data-scroll-lock-fill-gap]'

    //set fillGapMethod for scroll-lock
    setFillGapMethod(this.fillGapMethod);

    // set FillGapSelector
    addFillGapSelector(this.fillGapSelector);

    // set fillGapTarget
    addFillGapTarget(this.fillGapElement);

    // set scrollBarWidth variable (prevent content jumping by using a max-width class when needed).
    document.documentElement.style.setProperty('--scrollBarWidth', getPageScrollBarWidth() + 'px');
  }

  handleState(event) {
    this.emit('change', event.target)

    this.target = event.target.getAttribute('data-modal-toggle')
  
    if (this.element.getAttribute('data-modal-target') == this.target && this.element.dataset.modalOverlay != 'active') {

        this.show(this.target)
    } else {

        this.hide(this.target)
    }

  }

  show (modal) {

    this.state = 'visible'

    // modal state
    this.element.dataset.modalOverlay = 'active'
    document.body.classList.add('modal-active', `overlay-${this.target}`)

    // toggle state
    this.toggle.setAttribute('aria-expanded', 'true')

    // focus
    this.trapFocus()

    //Pass the element to the argument and disable scrolling on the page
    disablePageScroll(this.scrollableElement);

  }

  hide (target) {

    this.state = 'hidden'

    // modal state
    this.element.dataset.modalOverlay = ''
    document.body.classList.remove('modal-active', `overlay-${this.target}`);

    // toggle state
    this.toggle.setAttribute('aria-expanded', 'false')

    // Also, pass the element to the argument and enable scrolling on the page
    enablePageScroll(this.scrollableElement);

    // Restore page focus
    this.returnFocus(this.toggle)

  }

  trapFocus (direction) {
    const focusableElements = 'a, input:not([type="hidden"]), textarea, button';
    const focusableInputs = 'input:not([type="hidden"]), textarea';

    const firstFocusableElement = this.element.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const focusableContent = this.element.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

    const firstFocusableInput = this.element.querySelectorAll(focusableInputs)[0]; // get first input/textarea to be focused inside modal

    if (direction == 'forwards') {
      if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        event.preventDefault();
        firstFocusableElement.focus(); // add focus for the first focusable element
      }
    } else if (direction == 'backwards') {
      if (document.activeElement === firstFocusableElement) {
        event.preventDefault();
        lastFocusableElement.focus(); // add focus for the last focusable element
      }
    } else { // set the initial focus when modal opens
      if (firstFocusableInput) {
        firstFocusableInput.focus();
        console.log('firstFocusableInput', firstFocusableInput)
      } else {
        this.element.focus();
        console.log('firstFocusableElement', firstFocusableElement)
      }
    }

  }

  returnFocus (activeElement) {
    activeElement.focus();
  }


  /**
   * Events.
   */

  onTouchDown (event) {
    // if we've clicked the modal toggle
    if (event.target.matches('[data-modal-toggle]')) {
      this.handleState(event)
    }

    if (event.target.matches('[data-modal-close]')) {
      //close modal
      this.hide()
    }
    
  }
     
  onKeyDown (event) {
    console.log('onKeyDown Modal', event.target)
    
    // if ENTER key pressed
    if (event && event.key === 'Enter' || event.keyCode === 23) {
      // if we've clicked the modal toggle
      if (event.target.matches('[data-modal-toggle]')) {
        this.handleState(event)
      }
    }
    // if ESC key pressed
    if (event && event.key === 'Escape') {
     // if esc key was not pressed in combination with ctrl or alt or shift
        const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
        if (isNotCombinedKey) {
          // escape key was pressed with out any group keys
          
          // removeActiveState for modal;
          // document.querySelector('[data-modal-toggle][aria-expanded="true"]').click();
          this.hide()
        }
        console.log('ESC key pressed!')
    }

    // if the modal is hidden, return
    if (this.state == 'hidden') return

    // if TAB key pressed
    if (event && event.key === 'Tab' || event.keyCode === 9) {
      if (event.shiftKey) {  
      // if shift key pressed for shift + tab combination
        this.trapFocus('backwards') 
      } else {  
      // if only TAB key pressed
        this.trapFocus('forwards') 
      }
    }

  }

  matchMedia (event) {
    if (event.matches) {
      // we're looking at the mobile view
    } else {
      // this is the desktop view
      this.hide()
    }
  }

  /**
   * Listeners.
   */
  addEventListeners () {
    window.addEventListener('keydown', this.onKeyDown.bind(this))

    this.maxWidth = parseInt(this.element.getAttribute('data-modal-max-width'))
    this.mediaQuery = `(max-width: ${this.maxWidth}px)`
    this.mediaQueryList = window.matchMedia(this.mediaQuery)

    this.mediaQueryList.addEventListener('change', this.matchMedia.bind(this))

  }


}
